import React, { useEffect, useRef } from 'react';
import './css/Profile.css'; // Assuming you have a CSS file for additional styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const Profile = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const technicalSkills = [
    { skill: 'AWS', value: 10 },
    { skill: 'Azure', value: 5 },
    { skill: 'GCP', value: 2 },
    { skill: 'Kubernetes', value: 8.5 },
    { skill: 'Docker', value: 8.5 },
    { skill: 'Terraform', value: 8.5 },
    { skill: 'Ansible', value: 9 },
    { skill: 'ELK', value: 6 },
    { skill: 'Grafana', value: 6 },
    { skill: 'Loki', value: 6 },
    { skill: 'Linux', value: 10 },
    { skill: 'Windows', value: 10 },
    { skill: 'PowerShell', value: 8 },
    { skill: 'Shell Script', value: 8 },
    { skill: 'Python', value: 9 },
    { skill: 'React', value: 2 },
    { skill: 'Server Management', value: 10 },
    { skill: 'Azre Devops', value: 7 },
  ];

  const personalSkills = [
    { skill: 'Problem-solving', value: 100 },
    { skill: 'Team collaboration', value: 100 },
    { skill: 'Effective communication', value: 100 },
  ];

  return (
    <div className="profile-container">
      <div className="card work-experience" ref={(el) => (sectionsRef.current[0] = el)}>
        <div className="card-body">
          <h2 className="card-title">Work Experience</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-content">
                <img src="Images/s&p.png" alt="S & P Global" className="timeline-image" />            
                <h3>S & P Global</h3>
                <h5>Lead DevOps Engineer (Jan-2021 - Present)</h5>
                <h4><u>Technologies/Tools Used:</u></h4> 
                <p>AWS, Docker, Kubernetes, Terraform, Ansible, Azure Devops, Python, Shell Script, Powershell Script, Gitlab, GitHub, ELK, Grafana, Loki, Otel</p>
                <h4><u>Description:</u></h4>
                <p>
                <ul>  
                  <li>Working to Creat infrastructure and it’s setup for dev, test and prod environment using terraform, ansible, packer</li>
                  <li>Created terraform modules for different services of AWS.</li>
                  <li>Created ansible playbook to setup different components ofthinkfolio applicatin, for database, otel agent etc.</li>
                  <li>Working to create azure devops build and release pipeline for different component and tasks</li>
                  <li>Created packer script for ami creation.</li>
                  <li>Working to provide docker and kubernetes support to running applications.</li>
                  <li>AWS Resouces setup and Managements.</li>
                </ul>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <img src="Images/sapient.png" alt="Publicis Sapient" className="timeline-image" />            
                <h3>Publicis Sapient (ADNOC)</h3>
                <h5>Senior DevOps and Infrastructure Engineer (July 2020 - Jan 2021)</h5>
                <h4><u>Technologies/Tools Used:</u></h4> 
                <p>Azure cloud, Azure Devops, Ansible, Terraform, EKS, ELK</p>
                <h4><u>Description:</u></h4>
                <p>
                <ul>
                  <li>Involve in creation of complete infrastructure of ADNOC.</li>
                  <li>Setup and working on Azure Environment with services like WVD, Storage, VMs, Firewall, VPC.</li>
                  <li>Setup and working on Azure DevOps.</li>
                  <li>Done ELK setup for monitoring</li>
                  <li>Working on Endur.</li>
                  <li>Created Ansible playbook to install and configure differentpackages in vms.</li>
                  <li>Responsibility to troubleshoot and resolve customer issues.</li>
                </ul>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <img src="Images/hcl.png" alt="HCL Technologies" className="timeline-image" />            
                <h3>HCL Technologies (BroadCom & COE)</h3>
                <h5>Senior DevOps Engineer (Dec 2017 - July 2020)</h5>
                <h4><u>Technologies/Tools Used:</u></h4> 
                <p>AWS, Azure, GCP, Jenkins, Kubernetes, Ansible, Terraform, Dcoker, Shell Script, Python</p>
                <h4><u>Description:</u></h4> 
                <p>
                <ul>
                  <li>Created different AWS Cloud Formation templates to create different AWS resources.</li>
                  <li>Created different ARM templates to create different Azure resources.</li>
                  <li>Created different GCP deployment template to create different GCP resources.</li>
                  <li>Created and managing infrastructure using Kubernetes and Docker</li>
                  <li>Created and managing CICD environment using Jenkins</li>
                  <li>Created Ansible playbook to install and perform various operations of APMI (Infrastructure monitoring tool) developed by Broadcom (CA Technologies).</li>
                  <li>Created Ansible playbook to trigger with Automic.</li>
                  <li>Created Ansible playbook to automate java and .Net Agent.</li>
                  <li>Created Jenkins jobs to create Docker image of APMIA and push to repository.</li>
                  <li>Created multiple Ansible libraries by using python.</li>
                  <li>Created shell script for functioning of APMIA.</li>
                  <li>Worked on AWS extension of APMIA to pull metrics from cloud watch for below services. EC2, S3, ELB, CLB, VPC, SQS, SNS</li>
                  <li>Worked on Azure extension of APMIA to pull metrics from monitor service of azure for below services. App service, storage, app service plan, VM, VM scalset, event hub, service bus.</li>
                </ul>
                </p>
                </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <img src="Images/times.png" alt="Times Internet" className="timeline-image" />            
                <h3>Times Internet Limited</h3>
                <h5>DevOps Engineer (June 2017 - Dec 2017)</h5>
                <h4><u>Technologies/Tools Used:</u></h4> 
                <p>Ansible, Jenkins, Kubernetes, Terraform, VMware, AWS, Azure, ELK, Python, shell script</p>
                <h4><u>Description:</u></h4> 
                <p>
                <ul>
                  <li>Created Ansible playbook for provisioning of VMs and configuration of applications/services in it.</li>
                  <li>Created Ansible playbook to manage infrastructure, hosted on AWS.</li>
                  <li>Manage resources hosted on different cloud platform like AWS, Azure.</li>
                  <li>Created CICD environment using Jenkins for fast and effective release of all Products of times internet limited.</li>
                  <li>Created python script to automate different process which needs to trigger on different condition for different projects.</li>
                  <li>Design infrastructure for hosting on Kubernetes Created ELK setup to log capture and monitoring.</li>
                </ul>
                </p>
                </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-content">
                <img src="Images/flipkart.png" alt="Flipkart" className="timeline-image" />            
                <h3>TeamLease Services (Flipkart)</h3>
                <h5>Systems Engineer (Sep 2014 - June 2016)</h5>
                <h4><u>Technologies/Tools Used:</u></h4> 
                <p>Linux, Shell Script, Nagios, Jenkins, Ansibble</p>
                <h4><u>Description:</u></h4> 
                <p>
                <ul>
                  <li>Installed and configure different application like web server, tomcat, mod_jk nginx.</li>
                  <li>Configured Jenkins job for build and deployment.</li>
                  <li>Configured Nagios to monitor infrastructure.</li>
                  <li>Created shell script for different process scheduling</li>
                  <li>Created Human resource management application using Asp.net as front end C# backend and SQL server database</li>
                </ul>
                </p>
                </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="card technical-skills" ref={(el) => (sectionsRef.current[1] = el)}>
        <div className="card-body">
          <h2 className="card-title">Technical Skills</h2>
          <div className="gauge-container-wrapper">
            {technicalSkills.map((skill, index) => (
              <div key={index} className="gauge-container">
                <CircularProgressbar
                  value={skill.value * 10} // Convert to percentage
                  text={`${skill.value} years`}
                  styles={buildStyles({
                    textColor: "#000000",
                    pathColor: "#4CAF50", // Green color
                    trailColor: "#D3D3D3",
                  })}
                />
                <h3 className="gauge-skill-name">{skill.skill}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="card personal-skills" ref={(el) => (sectionsRef.current[2] = el)}>
        <div className="card-body">
          <h2 className="card-title">Personal Skills</h2>
          <div className="gauge-container-wrapper">
            {personalSkills.map((skill, index) => (
              <div key={index} className="gauge-container">
                <CircularProgressbar
                  value={skill.value}
                  text={`${skill.value}%`}
                  styles={buildStyles({
                    textColor: "#000000",
                    pathColor: "#4CAF50", // Green color
                    trailColor: "#D3D3D3",
                  })}
                />
                <h3 className="gauge-skill-name">{skill.skill}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="card education" ref={(el) => (sectionsRef.current[3] = el)}>
        <div className="card-body">
          <h2 className="card-title">Education</h2>
          <ul>
            <li><strong>Bachelor's Degree in Information Technology</strong> - Uttar Pradesh Technical University (2010 - 2014)</li>
          </ul>
        </div>
      </div>
      
      <div className="card personal-details" ref={(el) => (sectionsRef.current[4] = el)}>
        <div className="card-body">
          <h2 className="card-title">Personal Details</h2>
          <ul>
            <li><FontAwesomeIcon icon={faMapMarkerAlt} className="fa-icon" /> Location: Noida, India</li>
            <li>Date of Birth: Sep 5, 1992</li>
          </ul>
        </div>
      </div>
      
      <div className="card communication-details" ref={(el) => (sectionsRef.current[5] = el)}>
        <div className="card-body">
          <h2 className="card-title">Communication Details</h2>
          <ul>
            <li><FontAwesomeIcon icon={faEnvelope} className="fa-icon" /> Email: <a href="mailto:utkarsh.srivastava9295@gmail.com">utkarsh.srivastava9295@gmail.com</a></li>
            <li><FontAwesomeIcon icon={faPhone} className="fa-icon" /> Phone: +91-xxxxxxxxxx</li>
            <li><FontAwesomeIcon icon={faLinkedin} className="fa-icon" /> LinkedIn: <a href="https://www.linkedin.com/in/utkarsh-srivastava-0a438676/" target="_blank" rel="noopener noreferrer">linkedin.com/in/utkarsh</a></li>
            <li><FontAwesomeIcon icon={faLinkedin} className="fa-icon" /> GitHub: <a href="https://github.com/arsh9295" target="_blank" rel="noopener noreferrer">github.com/in/utkarsh</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Profile;